import React, { useEffect } from "react";
import navigate from "helpers/navigate";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "@reach/router";
import getUrlParams from "helpers/get-url-params";
import { authenticateCustomer } from "actions/account/auth";
import { CUSTOMER_STATE } from "utils/constants";
import { useGlobalContext } from "context/global";
import Skeleton from "components/skeleton";

const PrivateRoute = ({ component: Component, showLoader, ...rest }) => {
	const { language } = useGlobalContext();
	const { customerState } = useSelector((state) => state.account.profile);
	const { isFetched } = useSelector((state) => state.account.subscription);
	const location = useLocation();
	const code = getUrlParams("code", location.search);
	const dispatch = useDispatch();

	useEffect(() => {
		if (code)
			dispatch(authenticateCustomer());
	}, []);

	useEffect(() => {
		if (!customerState || code) return;
		if (customerState === CUSTOMER_STATE.Logged_out) navigate("/account/login");

	}, [customerState, language]);

	return customerState === CUSTOMER_STATE.Logged_in && isFetched ? <Component {...rest} /> : showLoader ?
		<div className="w-11/12 mx-auto md:w-5/6 hd-screen-max-width my-8 py-4">
			<Skeleton amount={22} />
		</div> : null;
};

export default PrivateRoute;
